<template>
  <div>
    <v-bottom-navigation v-model="value" :background-color="color" dark shift>
      <v-btn @click="togglePage = false">
        <span>Graph</span>

        <v-icon class="fas fa-chart-pie"></v-icon>
      </v-btn>
      <v-btn @click="togglePage = true">
        <span>Transaction</span>

        <v-icon class="fas fa-table"></v-icon>
      </v-btn>
    </v-bottom-navigation>
    <div>
      <report v-if="togglePage" />
      <dashboard v-else />
    </div>
  </div>
</template>

<script>
import dashboard from "../views/dashboard";
import report from "../views/report";
export default {
  components: {
    dashboard,
    report,
  },
  data: () => ({ value: 1, togglePage: true }),

  computed: {
    color() {
      switch (this.value) {
        case 0:
          return "indigo";
        case 1:
          return "teal";

        default:
          return "blue-grey";
      }
    },
  },
};
</script>

<style>
</style>